module.exports = __webpack_public_path__ + "assets/6fb192ad5d579b630e0be6a2479b8056.png";